export default __webpack_public_path__ + "static/media/tollfree_inbound.dca7928d.svg";